import type { Translations } from '../../../types'
import shopProductTypeMessages from './productType'
import shopEditorMessages from './editor'
import shopVariantModalMessages from './variantModal'
import shopFeaturedImageMessages from './featuredImage'
import shopMediaLibraryMessages from './mediaLibrary'
import shopPriceStockMessages from './priceStock'
import shopVariantsCardMessages from './variantsCard'
import shopValidationMessages from './validation'
import shopMediaMessages from './media'
import shopProductsMessages from './products'
import shopCategoriesMessages from './categories'
import shopMigrationsMessages from './migrations'

const shopMessages: Translations = {
  ...shopProductTypeMessages,
  ...shopEditorMessages,
  ...shopVariantModalMessages,
  ...shopFeaturedImageMessages,
  ...shopMediaLibraryMessages,
  ...shopPriceStockMessages,
  ...shopVariantsCardMessages,
  ...shopValidationMessages,
  ...shopMediaMessages,
  ...shopProductsMessages,
  ...shopCategoriesMessages,
  ...shopMigrationsMessages,
}

export default shopMessages
